/** Default avatar when a user has no custom photo or marketplace icon. */
import defaultProfileIconUrl from "../assets/branding/default-profile-icon.png";

export const DEFAULT_PROFILE_ICON_URL = defaultProfileIconUrl;

export default defaultProfileIconUrl;
